module.exports = __webpack_public_path__ + "static/loading-47f6ffc4547e838396b7785992b53316.gif";